export default __webpack_public_path__ + "static/media/ba-llb.3e480aa3.webp";